import axios from "axios";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { configuration } from "../../appConfig";
import "./USPriceTable.css";
import "./canadapricetable.css";
import "./DNSPriceTable.css";
import CanadaPrice from "./PricesCanada.json";
import SgiPrice from "./PriceSgiEstevanCanada.json";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
import Lightbox from "react-image-lightbox";
import { reportAuthorized } from "../../redux/actions/reportAuthorized";
function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

const [glue_percentage, replace_percentage] = [25.0, 25.0];
const extraParts = [
  "Trunk",
  "LeftFrontTyre",
  "LeftBackTyre",
  "RightFrontTyre",
  "RightBackTyre",
  "FrontBumper",
  "BackBumper",
  "Underbody",
  "Inside",
];

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

const arrDataErsetzen = {
  //0. Hood
  Hood: [
    "Front Grill",
    "Fog Light Left",
    "Fog Light Right",
    "Head Light Left",
    "Head Light Right",
    "Hood Liner Clips",
    "Windshield",
    "Hood Deflector",
    "Hood Vent Left",
    "Hood Vent Right",
    "3M Hood",
    "Cowel",
  ],
  // 1. Left Front Fender
  LeftFrontFender: ["Marker Light", "3M", "Applique Fender Moulding"],
  // 2. Left Front Door
  LeftFrontDoor: [
    "Belt Moulding",
    "Applique Moulding Front",
    "Applique Moulding Rear",
    "Door Moulding Upper",
    "Drip Moulding",
    "Door Handle",
    "Key Pad",
    "Door Glass",
    "Mirror Unit",
    "Mirror Glass",
  ],
  // 3. Left Back Door
  LeftBackDoor: [
    "Applique Moulding Rear",
    "Applique Moulding Front",
    "Belt Moulding",
    "Door Moulding Upper",
    "Door Glass",
  ],
  // 4. Left Back Fender
  LeftBackFender: [
    "Quarter Glass Moulding",
    "3M",
    "Inner TailLight",
    "Outter TailLight",
    "Applique Moulding Front",
    "Applique Moulding Rear",
    "Quarter Glass",
  ],
  // trunk
  Trunk: [
    "Back Glass",
    "Upper Break Light",
    "Left Break Light",
    "Right Break Light",
    "Deck Lid Mouldings",
  ],
  // 5. Trunk Cover
  TrunkCover: [
    "Back Glass",
    "Upper Break Light",
    "Left Break Light",
    "Right Break Light",
    "Deck Lid Mouldings",
  ],
  // 6. Right Back Fender
  RightBackFender: [
    "Quarter Glass Moulding",
    "3M",
    "Inner TailLight",
    "Outter TailLight",
    "Applique Moulding Front",
    "Applique Moulding Rear",
    "Quarter Glass",
  ],
  // 7. Right Back Door
  RightBackDoor: [
    "Applique Moulding Rear",
    "Applique Moulding Front",
    "Belt Moulding",
    "Door Moulding Upper",
    "Door Glass",
  ],
  // 8. Right Front Door
  RightFrontDoor: [
    "Belt Moulding",
    "Applique Moulding Front",
    "Applique Moulding Rear",
    "Door Moulding Upper",
    "Drip Moulding",
    "Door Handle",
    "Door Glass",
    "Mirror Unit",
    "Mirror Glass",
  ],
  // 9. Right Front Fender
  RightFrontFender: ["Marker Light", "3M", "Applique Fender Moulding"],
  // 10. Roof
  Roof: [
    "Antenna",
    "Roof Marker Light",
    "Roof Rack Left",
    "Roof Rack Right",
    "Roof Moulding Right",
    "Roof Moulding Left",
  ],
  // 11. Left Roof Frame
  LeftRoofFrame: [],
  // 12. Right Roof Frame
  RightRoofFrame: [],
};
const roofAdditionalParts = [
  {
    name: "Sunroof (S)",
    value: "smallSunroof"
  },
  {
    name: "Sunroof (B)",
    value: "bigSunroof"
  },
  {
    name: "Roof Rack",
    value: "roofRack"
  },
  {
    name: "In Roof DVD Screen (S)",
    value: "smallInRoofDVD"
  },
  {
    name: "In Roof DVD Screen (B)",
    value: "bigInRoofDVD"
  }
]
const trunkAdditionalParts = [
  {
    name: "Rear hatch",
    value: "rearHatch"
  }
]

class SgiEstevanPriceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Dents: [],
      data: {},
      words: {},
      lang: "us",
      ALUPercentage: "",
      LAKPercentage: "",
      CarTypeArr: ["Van", "SUV", "Extended Cab Truck"],
      loading: false,
      ShowPrice: false,
      PricePerHour: 0,
      insuaranceProvider: {},
      imageArr: [],
      imageArrDamage: [],
      modal: false,
      carType: ""
    };
  }

  async componentDidMount() {
    this.getLang();
    await this.getData();
    this.getScanImages();
  }

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images
            ? images.filter((image) => image.includes(keyword))
            : [];
        };

        const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender"),
        ];

        const right = [
          ...filterImages(
            data.RightFrontFender || data.right,
            "RightFrontFender"
          ),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(
            data.RightBackFender || data.right,
            "RightBackFender"
          ),
        ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,
          ],
        });
        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage, "LeftBackFender"),
        ];

        const rightDamage = [
          ...filterImages(data.RightFrontFender_damage, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage, "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage, "RightBackFender"),
        ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getData = async () => {
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    let url = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
    await axios
      .get(url)
      .then((res) => {
        if (res.data) {
          this.props.reportAuthorized({
            Authorized: res.data.Authorized,
            DATReportAuthorized: res.data.DATReportAuthorized,
            MiniReportAuthorized: res.data.MiniReportAuthorized,
            FullReportAuthorized: res.data.FullReportAuthorized,
            DetailedReportAuthorized: res.data.DetailedReportAuthorized,
            AmericanReportAuthorized: res.data.AmericanReportAuthorized,
          });
          if (res.data.Client != "") {
            this.getInsurenceClients();
          }
          res.data.Dents &&
            res.data.Dents.map((dent, index) => {
              dent.arrErsetzen = !extraParts.includes(dent.Part)
                ? arrDataErsetzen[dent.Part]
                : [];
              // dent.arrDataAE = !extraParts.includes(dent.Part) ? arrDataAE[dent.Part] : [];
            });
          this.setState(
            {
              data: res.data,
              Dents: res.data.Dents,
              ShowPrice: res.data.ShowPrice,
              Client: res.data.Client,
              carType: res.data.CarType == "Extended Cab Truck" ? "extendedCabTruck" : res.data.CarType == "Van" ? "van" : res.data.CarType == "SUV" ? "suv" : "normal"
            },
            () => {
              if (
                this.state.data.hasOwnProperty("Authorized") &&
                this.state.data.Authorized
              ) {
                this.setState(
                  {
                    PricePerHour: res.data.PricePerHour
                      ? parseInt(res.data.PricePerHour)
                      : 0,
                    ALUPercentage: res.data.ALUPercentage
                      ? parseInt(res.data.ALUPercentage)
                      : 0,
                    LAKPercentage: res.data.LAKPercentage
                      ? parseInt(res.data.LAKPercentage)
                      : 0,
                    // PricePerHour: !this.state.PricePerHour ? (res.data.PricePerHour ? parseInt(res.data.PricePerHour) : 0) : this.state.PricePerHour,
                    // ALUPercentage: !this.state.ALUPercentage ? (res.data.ALUPercentage ? parseInt(res.data.ALUPercentage) : 0) : this.state.ALUPercentage,
                    // LAKPercentage: !this.state.LAKPercentage ? (res.data.LAKPercentage ? parseInt(res.data.LAKPercentage) : 0) : this.state.LAKPercentage,
                  },
                  () => this.getFallbackDetails()
                );
              } else {
                this.getFallbackDetails();
              }
              this.mergeTrunkAndTrunkCover(res.data.Dents);
            }
          );
        }
      })
      .catch((err) => { });
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      const response = await axios.post(url);
      if (response.data) {
        response.data.map((info) => {
          if (
            this.state.Client &&
            this.state.Client != undefined &&
            this.state.Client != "" &&
            this.state.Client.toLocaleLowerCase() &&
            this.state.Client.toLocaleLowerCase() ==
            info.Name.toLocaleLowerCase()
          ) {
            this.setState({ insuaranceProvider: info });
          }
        });
      }
    }
  };

  mergeTrunkAndTrunkCover = (dents) => {
    let trunkRow = dents[findWithAttr(dents, "Part", "Trunk")];
    dents.map((row) => {
      if (row.Part === "TrunkCover") {
        row.A = (row.A ? row.A : 0) + (trunkRow.A ? trunkRow.A : 0);
        row.B = (row.B ? row.B : 0) + (trunkRow.B ? trunkRow.B : 0);
        row.C = (row.C ? row.C : 0) + (trunkRow.C ? trunkRow.C : 0);
        // row.D = (row.D ? row.D : 0) + (trunkRow.D  ? trunkRow.D  : 0)
        row.D = (row.D ? row.D : 0) + (trunkRow.D ? trunkRow.D : 0);
        row.TotalDents = row.A + row.B + row.C + row.D;
        trunkRow.A = 0;
        trunkRow.B = 0;
        trunkRow.C = 0;
        // trunkRow.D = 0
        trunkRow.D = 0;
        trunkRow.TotalDents = 0;
      }
    });
    this.setState({
      Dents: dents,
    });
  };

  getFallbackDetails = async () => {
    let partnerId = localStorage.getItem("partnerId");
    const url = configuration.getFallbackDetails + `?partner_id=${partnerId}`;
    const res = await axios.get(url);

    function hexToRgb(hex) {
      hex = hex.replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => "#" + r + r + g + g + b + b
      );
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
        : null;
    }

    let rgbColor = hexToRgb(
      this.state.insuaranceProvider.PrimaryColor || res.data.primary_color
    );
    let rgbaColor = `rgba(${rgbColor && rgbColor.r}, ${rgbColor && rgbColor.g
      }, ${rgbColor && rgbColor.b}, 0.20)`;
    this.props.getSelectedPartnerId({
      duplicateSelectedPartnerId:
        res.data.vin_duplicate_partner_id.length > 0
          ? res.data.vin_duplicate_partner_id
          : [],
      isDuplicateVin: res.data.is_vin_duplicate,
    });
    this.setState({
      ALUPercentage: res.data.alu,
      LAKPercentage: res.data.lak,
      table_footer_color: res.data.table_footer_color,
      carDetails: res.data.carDetails,
      PrimaryColor: res.data.primary_color || "#FF0000",
      SecondaryColor: res.data.secondary_color || "#000000",
      PrimaryTextColor: res.data.primary_text_color || "#000000",
      SecondaryTextColor: res.data.secondary_text_color || "#fff",
      rgbaColor: rgbaColor,
    }, () => { this.getCartypeValue() });

    if (res.data.success !== false) {
      if (!this.state.data.Authorized) {
        this.setState({
          PricePerHour: !this.state.PricePerHour
            ? res.data.PricePerHour
            : this.state.PricePerHour,
          ALUPercentage: !this.state.ALUPercentage
            ? res.data.alu
            : this.state.ALUPercentage,
          LAKPercentage: !this.state.LAKPercentage
            ? res.data.lak
            : this.state.LAKPercentage,
        });
      }
    }
  };

  // For change Dents
  handleDentsChanges = (part, e, index) => {
    const { name, value } = e.target;
    const { data, Dents } = this.state;
    if (name == "F") {
      if (value <= Dents[index]["TotalDents"]) {
        Dents[index]["F"] = parseInt(value);
      }
    } else {
      Dents[index][name] = parseInt(value);
    }
    let obj = Dents[index];
    Dents[index]["TotalDents"] = parseInt(
      (obj.A ? obj.A : 0) +
      (obj.B ? obj.B : 0) +
      (obj.C ? obj.C : 0) +
      (obj.D ? obj.D : 0) +
      (obj.E ? obj.E : 0)
    );
    if (Dents[index]["TotalDents"] == 0) {
      Dents[index]["F"] = 0
    }
    this.setState({
      Dents: Dents,
      data: {
        ...data,
        Dents: Dents,
      },
    });
  };

  // For get dents range and type
  getSeverityClass = (row, removeE) => {
    // const { A, B, C, D } = row;
    // let parts = ["Hood", "Roof", "TrunkCover", "Trunk"];
    // let [max, maxValueKey, range, totalDents] = ["", "", "", row.TotalDents];
    // var obj = { A, B, C, D };
    // var typeObj = {
    //   A: "DIME",
    //   B: "NKL",
    //   C: "QTR",
    //   D: "OS",
    // };
    // if (removeE) {
    //   delete obj.D;
    //   delete typeObj.D;
    // }
    // for (const key in obj) {
    //   if (Object.hasOwnProperty.call(obj, key)) {
    //     const value = obj[key];
    //     if (value > max) {
    //       max = value;
    //       maxValueKey = key;
    //     }
    //   }
    // }
    const totalDents = row.TotalDents;
    let range = "";

    if (totalDents >= 1 && totalDents <= 5) {
      range = "VERY LIGHT (1 TO 5)";
    } else if (totalDents >= 6 && totalDents <= 15) {
      range = "LIGHT (6 TO 15)";
    } else if (totalDents >= 16 && totalDents <= 30) {
      range = "MODERATE (16 TO 30)";
    } else if (totalDents >= 31 && totalDents <= 50) {
      range = "MEDIUM (31 TO 50)";
    } else if (totalDents >= 51 && totalDents <= 75) {
      range = "HEAVY (51 TO 75)";
    } else if (totalDents >= 76 && totalDents <= 100) {
      range = "VERY HEAVY (76 TO 100)";
    } else if (totalDents >= 101 && totalDents <= 150) {
      range = "SUBSTANTIAL (101 TO 150)";
    } else if (totalDents >= 151 && totalDents <= 200) {
      range = "SERVE (151 TO 200)";
    } else if (totalDents >= 201 && totalDents <= 250) {
      range = "VERY SERVE (201 TO 250)";
    } else if (totalDents >= 251 && totalDents <= 300) {
      range = "EXCESSIVE (301 TO 500)";
    } else if (totalDents >= 301 && totalDents <= 350) {
      range = "EXTREME (301 TO 350)";
    } else if (totalDents >= 351 && totalDents <= 400) {
      range = "LIMIT (351 TO 400)";
    } else if (totalDents >= 401) {
      range = "NON-REPAIRABLE";
    }

    return {
      range,
    };
  };

  // For checkbox & dropdown
  change = (part, e, index, isPaintCheckBox) => {
    const { name, checked, value } = e.target;
    const { data, Dents } = this.state;
    if (name == "Plastic") {
      Dents[index]["A"] = 0;
      Dents[index]["AW"] = 0;
      Dents[index]["Alu"] = false;
      Dents[index]["B"] = 0;
      Dents[index]["C"] = 0;
      Dents[index]["D"] = 0;
      Dents[index]["Ersetzen"] = [];
      Dents[index]["Glue"] = false;
      Dents[index]["OriginalAw"] = 0;
      Dents[index]["Push2paint"] = false;
      Dents[index]["Replace"] = false;
      Dents[index]["TotalDents"] = 0;
      Dents[index]["corrosionProtection"] = 0;
    }
    if (index === -1) {
      this.setState(
        {
          data: { ...data, [name]: value },
        },
        () => {
          // name === 'CarType' && this.handleSave();
        }
      );
    } else {
      name !== "Push2paint"
        ? (Dents[index][name] = checked)
        : (checked
          ? this.getTotalCorrosionProtection() +
          (Dents[index]["corrosionProtection"]
            ? Dents[index]["corrosionProtection"]
            : 0)
          : this.getTotalCorrosionProtection()) <= 30 &&
        (Dents[index][name] = checked);

      this.setState(
        {
          Dents: Dents,
          data: {
            ...data,
            Dents: Dents,
          },
        },
        () => {
          // this.handleSave()
        }
      );
    }
  };

  // getOriginalPrice = (row, excludeOSPrice) => {
  //   const { CarTypeArr, data, PricePerHour } = this.state;
  //   let [severityClass, part, maxValue, price] = [
  //     this.getSeverityClass(row, true),
  //     "",
  //     "",
  //     0.0,
  //   ];
  //   maxValue = row.TotalDents;
  //   SgiPrice["price"] &&
  //     SgiPrice["price"].length &&
  //     SgiPrice["price"].map((obj) => {
  //       if (row.Part == "Hood") {
  //         console.log(obj.min, obj.max, maxValue);
  //       }

  //       if (obj.min <= maxValue && obj.max >= maxValue) {
  //         console.log("if");

  //         price = obj.value
  //       }else {
  //         console.log("else");

  //         price = 0
  //       }
  //     });

  //   // if (!price) {
  //   //   if (!excludeOSPrice) {
  //   //     price = row.D ? row.D * parseInt(PricePerHour) : 0;
  //   //     if (row.Part === "Roof" && CarTypeArr.includes(data.CarType)) {
  //   //       price = price + price * 0.25;
  //   //     }
  //   //   }
  //   // } else if (price !== "CR") {
  //   //   price = excludeOSPrice
  //   //     ? price
  //   //     : (price ? price : 0) + (row.D ? row.D * parseInt(PricePerHour) : 0);
  //   //   if (row.Part === "Roof" && CarTypeArr.includes(data.CarType)) {
  //   //     price = price + price * 0.25;
  //   //   }
  //   // } else if (excludeOSPrice) {
  //   //   price = 0;
  //   // }
  //   return parseFloat(price);
  // };

  // getAluGlueAddedPrice = (row) => {
  //   const { ALUPercentage } = this.state;
  //   let [isCR, originalPrice, aluPr, gluePr, replacePr, incPR, finalPrice] = [
  //     this.getOriginalPrice(row) == 0
  //       ? true
  //       : false,
  //     this.getOriginalPrice(row),
  //     parseFloat(ALUPercentage),
  //     parseFloat(glue_percentage),
  //     parseFloat(replace_percentage),
  //     0,
  //     0,
  //   ];

  //   row.OriginalAw = originalPrice;
  //   // if(!row.A && !row.B && !row.C && !row.D && !row.D) {
  //   if (!row.A && !row.B && !row.C && !row.D) {
  //     row.AW = "0.00";
  //     return "0.00";
  //   }

  //   if (!isCR) {
  //     if (row.Alu && row.Glue && row.Replace) {
  //       incPR = aluPr + gluePr + replacePr;
  //     } else if (row.Alu && row.Glue) {
  //       incPR = aluPr + gluePr;
  //     } else if (row.Glue && row.Replace) {
  //       incPR = gluePr + replacePr;
  //     } else if (row.Alu) {
  //       incPR = aluPr;
  //     } else if (row.Glue) {
  //       incPR = gluePr;
  //     } else if (row.Replace) {
  //       incPR = replacePr;
  //     } else {
  //       incPR = 0;
  //     }

  //     if (incPR !== 0) {
  //       finalPrice =
  //         0 ||
  //         parseFloat(originalPrice) +
  //           (parseFloat(this.getOriginalPrice(row, true)) * incPR) / 100.0;
  //     } else {
  //       finalPrice = originalPrice;

  //     }
  //     row.Push2paint &&
  //       (finalPrice =
  //         finalPrice + (row.corrosionProtection ? row.corrosionProtection : 0));

  //     return finalPrice.toFixed(2);
  //   }else {
  //     return `${SgiPrice["price"][SgiPrice["price"].length-1].value} CR`
  //   }
  // };

  getOriginalPrice = (row, excludeOSPrice) => {
    const { CarTypeArr, data, PricePerHour } = this.state;
    let [severityClass, part, maxValue, price] = [
      this.getSeverityClass(row, true),
      "",
      "",
      0.0,
    ];
    maxValue = row.TotalDents;
    let lastPrice = SgiPrice["price"][SgiPrice["price"].length - 1].value; // Fetch last value

    SgiPrice["price"] &&
      SgiPrice["price"].length &&
      SgiPrice["price"].some((obj) => {
        if (obj.min <= maxValue && obj.max >= maxValue) {
          if (row.E > 0) {
            price = 0;
            return false
          } else {
            price = obj.value;
            return true;
          }
        } else {
          if (row.E > 0) {
            price = 0;
            return false
          } else {
            price = lastPrice;
            return false;
          }

        }
      });
    return parseFloat(price) || price; // Return either a number or the "CR" string
  };
  getAluGlueAddedPrice = (row) => {
    const { ALUPercentage } = this.state;
    let [
      isCR,
      originalPrice,
      aluPr,
      gluePr,
      replacePr,
      incPR,
      finalPrice,
      B,
      C,
      D,
      E,
      F
    ] = [
        this.getOriginalPrice(row) === 0 ? true : false,
        this.getOriginalPrice(row), // Fetch original price
        parseFloat(ALUPercentage),
        parseFloat(glue_percentage),
        parseFloat(replace_percentage),
        0,
        0,
        row.B,
        row.C,
        row.D,
        row.E,
        row.F
      ];
    const totalDents = row.TotalDents;

    row.OriginalAw = originalPrice;
    if (!row.A && !row.B && !row.C && !row.D && !row.E) {
      row.AW = "0.00";
      return "0.00";
    }
    if (B > 0) {
      let BPrice = B * 30;
      originalPrice = originalPrice + BPrice;
    }
    if (C > 0) {
      let CPrice = 0;
      if (row.Part == "LeftRoofFrame" || row.Part == "RightRoofFrame") {
        CPrice = C * 170;
      }else {
        CPrice = C * 120;
      }
      originalPrice = originalPrice + CPrice;
    }
    if (D > 0) {
      let DPrice = 0;
      if (row.Part == "LeftRoofFrame" || row.Part == "RightRoofFrame") {
        DPrice = D * 320;
      } else {
        DPrice = D * 270;
      }
      originalPrice = originalPrice + DPrice;
    }
    if (E > 0) {
      row.AW = "CR";
      originalPrice = 0;
      return "CR";
    }
    if (totalDents > 0) {
      if (F > 0) {
        const FPrice = F * 50;
        originalPrice = originalPrice + FPrice;
      }
    }
    if (!isCR) {
      if (row.Alu && row.Glue && row.Replace) {
        incPR = aluPr + gluePr + replacePr;
      } else if (row.Alu && row.Glue) {
        incPR = aluPr + gluePr;
      } else if (row.Glue && row.Replace) {
        incPR = gluePr + replacePr;
      } else if (row.Alu) {
        incPR = aluPr;
      } else if (row.Glue) {
        incPR = gluePr;
      } else if (row.Replace) {
        incPR = replacePr;
      } else {
        incPR = 0;
      }
    }
    // Adjust final price based on increment percentage
    if (incPR !== 0) {
      finalPrice =
        parseFloat(originalPrice) +
        (parseFloat(this.getOriginalPrice(row, true)) * incPR) / 100.0;
    } else {
      finalPrice = originalPrice;
    }

    row.Push2paint &&
      (finalPrice += row.corrosionProtection ? row.corrosionProtection : 0);


    row.AW = finalPrice.toFixed(2);
    if (totalDents == 400 || totalDents < 400) {
      return finalPrice.toFixed(2);
    } else {
      return `${finalPrice.toFixed(2)} + CR`;
    }
    // } else {
    //   return `${SgiPrice["price"][SgiPrice["price"].length - 1].value} CR`;
    // }
  };

  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images =
        configuration.imagePath == "https://backend.drivenscan.live" &&
          this.props.toggleReportDamageImage
          ? this.state.imageArrDamage
          : this.state.imageArr;
      const imageArr =
        images &&
        images.length > 0 &&
        images.filter((image) => {
          const spiltUrl =
            image.split("/")[
            configuration.imagePath == "https://backend.drivenscan.live" &&
              this.props.toggleReportDamageImage
              ? 7
              : 6
            ];
          const part = isPlastic
            ? spiltUrl && spiltUrl.split("_")[0]
            : spiltUrl && spiltUrl.split("_")[1];
          return part === partName;
        });
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  changeErsetzen = (event, index, value, key) => {
    const { Dents, data } = this.state;
    // const totalDents = Dents[index].TotalDents;
    const ersetzenArr = Array.isArray(Dents[index]["Ersetzen"])
      ? Dents[index]["Ersetzen"]
      : [];

    if (event.target.checked) {
      // if (key === "Ersetzen") {
      ersetzenArr.push(`${value}`);
      // Dents[index]["Ersetzen"] = [];
      // }
    } else {
      ersetzenArr.map((val, indx) => {
        if (value === val) {
          ersetzenArr.splice(indx, 1);
        }
      });
    }

    Dents[index]["Ersetzen"] = ersetzenArr;
    // Dents[index]["Ersetzen"] = [];
    this.setState({ data });
  };

  getTotalCorrosionProtection = () => {
    const { Dents } = this.state;
    let totalCorrosionProtection = 0;
    totalCorrosionProtection =
      Dents &&
      Dents.reduce((acc, num) => {
        if (!extraParts.includes(num.Part) && num.Push2paint) {
          return (
            parseFloat(acc) +
            parseFloat(
              num.hasOwnProperty("corrosionProtection")
                ? num.corrosionProtection
                : 0
            )
          );
        } else {
          return parseFloat(acc);
        }
      }, 0);
    return totalCorrosionProtection;
  };

  getTotal = () => {
    const { Dents } = this.state;
    let grandTotal = 0;
    grandTotal =
      Dents &&
      Dents.reduce((acc, num) => {
        if (!extraParts.includes(num.Part)) {
          return (
            parseFloat(acc) +
            parseFloat(
              this.getAluGlueAddedPrice(num) &&
                this.getAluGlueAddedPrice(num) !== "CR"
                ? this.getAluGlueAddedPrice(num)
                : 0
            )
          );
        } else {
          return parseFloat(acc);
        }
      }, 0);
    return grandTotal.toFixed(2);
  };
  getGrandTotal = () => {
    const { Dents } = this.state;
    let grandTotal = 0;
    let totalAdditionalRI = 0;
    let totalCarType = 0;
    let total = 0;
    grandTotal = this.getTotal();
    totalAdditionalRI = this.getAdditionalRI();
    totalCarType = this.getCartypeValue();
    total = parseFloat(grandTotal) + parseFloat(totalAdditionalRI) + parseFloat(totalCarType);

    return total.toFixed(2);
  };

  getTotalDentCount = () => {
    const { Dents } = this.state;
    let totalDents =
      Dents &&
      Dents.reduce((acc, num) => {
        if (
          num.Part !== "LeftFrontTyre" &&
          num.Part !== "LeftBackTyre" &&
          num.Part !== "RightFrontTyre" &&
          num.Part !== "RightBackTyre" &&
          num.Part !== "FrontBumper" &&
          num.Part !== "BackBumper" &&
          num.Part !== "Underbody" &&
          num.Part !== "Inside"
        ) {
          return parseInt(acc) + parseInt(this.getTotalDents(num));
        } else {
          return parseInt(acc);
        }
      }, 0);
    return totalDents;
  };

  handleSave = async () => {
    const { data, ShowPrice, PricePerHour, LAKPercentage, ALUPercentage } =
      this.state;
    this.setState({
      loading: true,
    });
    let payload = {
      ...data,
      Amount: await parseFloat(this.getTotal()),
      ShowPrice,
      TotalDentCount: this.getTotalDentCount(),
      PricePerHour: parseFloat(PricePerHour || 0),
      ALUPercentage: parseFloat(ALUPercentage || 0),
      LAKPercentage: parseFloat(LAKPercentage || 0),
      IsPriceTableUpdated: true,
      PartnerID: localStorage.getItem("partnerId"),
    };
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${!data.TabViewUpdated}`;

    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status === 200) {
          Toast.fire({
            type: "success",
            title: "Data saved successfully",
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          Toast.fire({
            type: "error",
            title: "Looks like something went wrong!",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  getTotalDents = (row) => {
    return (
      (row.A ? row.A : 0) +
      (row.B ? row.B : 0) +
      (row.C ? row.C : 0) +
      (row.D ? row.D : 0) +
      (row.E ? row.E : 0)
    );
  };

  handleToggle = (e) => {
    const { name, checked } = e.target;
    this.setState(
      {
        [name]: checked,
      },
      () => this.handleSave()
    );
  };

  isCRIncludes = () => {
    const { Dents } = this.state;
    return (
      Dents &&
      Dents.some(
        (r) =>
          ![
            "Trunk",
            "Inside",
            "Underbody",
            "FrontBumper",
            "BackBumper",
            "LeftFrontTyre",
            "LeftBackTyre",
            "RightFrontTyre",
            "RightBackTyre",
          ].includes(r.Part) && this.getAluGlueAddedPrice(r).includes("CR")
      )
    );
  };

  changeAE = (event, index, value, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;
    const aeArr = Array.isArray(Dents[index]["AE"]) ? Dents[index]["AE"] : [];

    if (event.target.checked) {
      // if (key === "AE") {
      aeArr.push(`${value}`);
      // Dents[index]["AE"] = [];
      // }
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }

    Dents[index]["AE"] = aeArr;
    // Dents[index]["AE"] = [];
    this.setState({ data });
  };
  getAdditionalRI = () => {
    const { Dents } = this.state;
    let totalAdditionalRI = 0;
    Dents.map((row) => {
      row.AdditionalRIPart && row.AdditionalRIPart.map((part) => {
        if (part === "bigSunroof") {
          totalAdditionalRI += 100;
        }
        if (part === "bigInRoofDVD") {
          totalAdditionalRI += 100;
        }
        if (part === "smallSunroof") {
          totalAdditionalRI += 50;
        }
        if (part === "roofRack") {
          totalAdditionalRI += 75;
        }
        if (part === "smallInRoofDVD") {
          totalAdditionalRI += 50;
        }
        if (part === "rearHatch") {
          totalAdditionalRI += 75;
        }
      })
    })
    return (totalAdditionalRI && totalAdditionalRI != 0) ? totalAdditionalRI.toFixed(2) : "0.00";
  }
  showAdditionalRiParts = () => {
    let mergedArray = [];
  
    this.state.Dents.forEach((row) => {
      if (row.Part === "Roof" || row.Part === "TrunkCover") {
        if (row.AdditionalRIPart) {
          mergedArray = [...mergedArray, ...row.AdditionalRIPart];
        }
      }
    });
  
    // Filter and map roof and trunk additional parts based on the mergedArray values
    const roofAdditionalNames = roofAdditionalParts
      .filter((part) => mergedArray.includes(part.value))
      .map((part) => part.name);
  
    const trunkAdditionalNames = trunkAdditionalParts
      .filter((part) => mergedArray.includes(part.value))
      .map((part) => part.name);
  
    // Merge both names into a single array
    const allAdditionalNames = [...roofAdditionalNames, ...trunkAdditionalNames];
  
    return allAdditionalNames;
  };
  
  
  
  getCartypeValue = () => {
    const { carType, carDetails } = this.state;
    let carTypeValue = 0;

    if (carDetails && Array.isArray(carDetails) && carDetails.length > 0) {
      const foundDetail = carDetails.find((val) => {
        return val.priceType == 3 && val.CarType.toLocaleLowerCase() == carType.toLocaleLowerCase();
      });
      if (foundDetail) {
        carTypeValue = foundDetail.price;
      }
    }
    return carTypeValue && carTypeValue != 0 ? parseInt(carTypeValue).toFixed(2) : "0.00";
  };

  changeAdditionalPart = (event, index, value) => {
    const { Dents } = this.state;
    const updatedDents = [...Dents];
    let additionalPartArr = Array.isArray(updatedDents[index]["AdditionalRIPart"])
      ? [...updatedDents[index]["AdditionalRIPart"]]
      : [];
  
    if (event.target.checked) {
      if (!additionalPartArr.includes(value)) {
        additionalPartArr.push(value);
      }
  
      if (value === "smallSunroof" && additionalPartArr.includes("bigSunroof")) {
        additionalPartArr = additionalPartArr.filter((val) => val !== "bigSunroof");
      } else if (value === "bigSunroof" && additionalPartArr.includes("smallSunroof")) {
        additionalPartArr = additionalPartArr.filter((val) => val !== "smallSunroof");
      } else if (value === "smallInRoofDVD" && additionalPartArr.includes("bigInRoofDVD")) {
        additionalPartArr = additionalPartArr.filter((val) => val !== "bigInRoofDVD");
      } else if (value === "bigInRoofDVD" && additionalPartArr.includes("smallInRoofDVD")) {
        additionalPartArr = additionalPartArr.filter((val) => val !== "smallInRoofDVD");
      }
  
    } else {
      additionalPartArr = additionalPartArr.filter((val) => val !== value);
    }
  
    updatedDents[index]["AdditionalRIPart"] = additionalPartArr;
    this.setState({ Dents: updatedDents });
  };
  
  handleChageCarType = (e) => {
    const { data } = this.state;
    this.setState({ carType: e.target.value == "Extended Cab Truck" ? "extendedCabTruck" : e.target.value == "Van" ? "van" : e.target.value == "SUV" ? "suv" : "normal" })
    this.setState(
      {
        data: { ...data, [e.target.name]: e.target.value },
      }
    );
  }

  render() {
    const dynamic_Table_Colors = {
      "--table-even-color": this.state.rgbaColor || "#E8F3FF",
      "--table-header-color":
        this.state.insuaranceProvider.PrimaryColor ||
        this.state.PrimaryColor ||
        "#D80707",
      "--table-footer-color":
        this.state.insuaranceProvider.SecondaryColor ||
        this.state.SecondaryColor ||
        "#000",
      "--table-header-text-color":
        this.state.insuaranceProvider.HeaderTextColor ||
        this.state.PrimaryTextColor ||
        "#000",
      "--table-footer-text-color":
        this.state.insuaranceProvider.FooterTextColor ||
        this.state.SecondaryTextColor ||
        "#fff",
    };

    const {
      data,
      Dents,
      ALUPercentage,
      CarTypeArr,
      loading,
      ShowPrice,
      modal,
      carType
    } = this.state;
    const { viewType, isAuthorized } = this.props;
    const totalCorrosionProtection = this.getTotalCorrosionProtection();
    let [colSpan, headSpan] = [
      viewType === "TabView" ? 14 : viewType === "reportMiniEU" ? 7 : 2,
      viewType === "TabView" ? 2 : 1,
    ];

    var order = [
      "Hood",
      "Roof",
      "TrunkCover",
      "LeftFrontFender",
      "LeftFrontDoor",
      "LeftBackDoor",
      "LeftRoofFrame",
      "LeftBackFender",
      "RightBackFender",
      "RightRoofFrame",
      "RightBackDoor",
      "RightFrontDoor",
      "RightFrontFender",
      // "Trunk",
    ];

    Dents &&
      Dents.length &&
      Dents.sort(function (a, b) {
        // sort based on the index in order Dents
        return order.indexOf(a.Part) - order.indexOf(b.Part);
      });

    const getPartName = (part) => {
      // let partName=  part.split(" ").map((word) => {
      //   return '<span>'+word.substring(0,1)+'</span>'+word.substring(1)
      //   // return `<b>${word.substring(0,1).toUpperCase()}</b>${word.substring(1)}`
      // });
      return part;
    };
    return (
      <>
        {/* <div className="container-fluid CanadaPrice-table-main-wrapper damage-calulation-canada-report"> */}
        <div className="container-fluid canada_main_table_wrapper">
          <div className="row canada-table-row-left-right">
            <div className="col-12 damage-summary-heading p-0 d-flex justify-content-between">
              <div className="row p-0 report-title-wrapper align-items-center">
                <div className="col-md-4 col-lg-4 p-0">
                  <h4 className="report-title p-0">
                    {this.lang("Damage Description")}
                  </h4>
                </div>
                {!this.props.is_extra_columns_visible_mini_fullreport ? (
                  <div className="col-md-8 col-lg-8 p-0">
                    <div className="row justify-content-end p-0">
                      <div className="col-6 col-lg-12 col-md-12 col-sm-12 col-12 text-right p-0 car_type_button_border">
                        {viewType === "TabView" ? (
                          <>
                            <div className="row justify-content-end">
                              <div className="admin-list mx-2 mt-1">
                                <label className="name pr-2">
                                  {this.lang("Show Price")}
                                </label>
                                <div className="switch-button switch-button-lg">
                                  {viewType === "TabView" ? (
                                    <input
                                      type="checkbox"
                                      name="ShowPrice"
                                      id="ShowPrice"
                                      value={true}
                                      onClick={(e) => this.handleToggle(e)}
                                      checked={ShowPrice}
                                      disabled={isAuthorized}
                                    />
                                  ) : (
                                    <p></p>
                                  )}
                                  <span>
                                    <label for="ShowPrice"></label>
                                  </span>
                                </div>
                              </div>
                              <div className="mx-2 mt-1">
                                <select
                                  onChange={(e) => this.change("", e, -1)}
                                  placeholder="Select Car Type"
                                  name="CarType"
                                  value={
                                    data.CarType
                                      ? data.CarType
                                      : (data.CarType = "Normal")
                                  }
                                  style={{
                                    opacity: "1",
                                    color: "black",
                                    padding: "4px 1px",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                  }}
                                  disabled={isAuthorized}
                                >
                                  {/* <option value={""}>--Select--</option> */}
                                  {["Normal", ...CarTypeArr].map((car, i) => (
                                    <option value={car} key={i}>
                                      {this.lang(car)}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              {viewType === "TabView" && (
                                <div className="mx-2 mt-1">
                                  <button
                                    id="updateTable"
                                    style={{
                                      backgroundColor: "#F20000",
                                      padding: "5px 15px",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontSize: "16px",
                                    }}
                                    onClick={this.handleSave}
                                    disabled={loading || isAuthorized}
                                  >
                                    {loading ? (
                                      <div
                                        className="spinner-border"
                                        role="status"
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                        }}
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    ) : (
                                      this.lang("Update Table")
                                    )}
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <p>
                            {this.lang("Car Type")}: {data.CarType || "Normal"}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* <div className="row all-price-table-wrapper swiss_price_table_all usprice_table_main canada-table-row-left-right"> */}
          {!this.props.is_extra_columns_visible_mini_fullreport ? (
            <div
              className={`row all-price-table-wrapper sgiestevan_pricetable_tabview_wrapper swiss_price_table_all usprice_table_main canada-table-row-left-right 
            ${viewType !== "TabView"
                  ? "canada-tableview-wrapper sgiestevan_pricetable_wrapper arrow_table_main_wrapper"
                  : ""
                } 
            ${viewType === "TabView" ? "arrow_table_main_wrapper" : ""}`}
            >
              <div className="col-lg-12 p-0">
                <div className="table-responsive">
                  <table className="table w-100">
                    <thead>
                      <tr>
                        <th
                          rowSpan={2}
                          style={{ ...dynamic_Table_Colors, minWidth: "180px" }}
                          className="both-top-border thead_bottom_border"
                        >
                          {this.lang("Damage Description")}
                        </th>
                        <th className="empty_row" rowSpan={2}></th>
                        {viewType !== "reportMiniEU" && (
                          <th
                            style={dynamic_Table_Colors}
                            className="both-top-border dark-gray-col thead_bottom_border"
                            rowSpan={2}
                          >
                            {this.lang("Dents Count")}
                          </th>
                        )}
                        {viewType === "TabView" && (
                          <th className="empty_row" rowSpan={2}></th>
                        )}
                        {viewType === "reportMiniEU" && (
                          <th
                            className="both-top-border"
                            style={dynamic_Table_Colors}
                            colSpan={5}
                          >
                            {this.lang("dentSize")}
                          </th>
                        )}
                        {viewType === "TabView" && (
                          <>
                            <th
                              className="top-left-border light-gray-col thead_bottom_border min-width-130"
                              style={dynamic_Table_Colors}
                              rowSpan={2}
                            >
                              {`A`}
                            </th>
                            <th
                              className="light-gray-col thead_bottom_border min-width-130"
                              style={dynamic_Table_Colors}
                              rowSpan={2}
                            >
                              {`B`}
                            </th>
                            <th
                              className="light-gray-col thead_bottom_border min-width-130"
                              style={dynamic_Table_Colors}
                              rowSpan={2}
                            >
                              {`C`}
                            </th>
                            {/* <th rowSpan={2}>HALF</th> */}
                            <th
                              className="light-gray-col thead_bottom_border min-width-130"
                              style={dynamic_Table_Colors}
                              rowSpan={2}
                            >
                              {`D`}
                            </th>
                            <th
                              className="light-gray-col thead_bottom_border top-right-border min-width-130"
                              style={dynamic_Table_Colors}
                              rowSpan={2}
                            >
                              {`E`}
                            </th>
                          </>
                        )}
                        <th className="empty_row" rowSpan={2}></th>
                        {viewType === "reportMiniEU" && (
                          <>
                            <th
                              className="both-top-border dark-gray-col thead_bottom_border"
                              style={dynamic_Table_Colors}
                              rowSpan={2}
                            >
                              Total Dents
                            </th>
                            <th className="empty_row" rowSpan={2}></th>

                          </>
                        )}
                        <th
                          className={`both-top-border orange-col thead_bottom_border`}
                          colSpan={headSpan}
                          rowSpan={2}
                          style={dynamic_Table_Colors}
                        >
                          BL
                        </th>
                        <th className="empty_row" rowSpan={2}></th>
                        {/* {viewType !== "reportMiniEU" && (
                          <th
                            className="both-top-border dark-gray-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                            rowSpan={2}
                          >
                            Type
                          </th>
                        )} */}
                        {/* <th className="empty_row" rowSpan={2}></th> */}
                        <th
                          className={`both-top-border yellow-col ${viewType !== "TabView" ? "thead_bottom_border" : ""
                            }`}
                          colSpan={headSpan}
                          rowSpan={viewType !== "reportMiniEU" ? 1 : 2}
                          style={dynamic_Table_Colors}
                        >
                          Alu
                        </th>
                        <th className="empty_row" rowSpan={2}></th>
                        <th
                          className={`both-top-border blue-col ${viewType !== "TabView" ? "thead_bottom_border" : ""
                            }`}
                          colSpan={headSpan}
                          rowSpan={viewType !== "reportMiniEU" ? 1 : 2}
                          style={dynamic_Table_Colors}
                        >
                          Glue
                        </th>
                        <th className="empty_row" rowSpan={2}></th>
                        <th
                          className={`both-top-border green-col ${viewType !== "TabView" ? "thead_bottom_border" : ""
                            }`}
                          colSpan={headSpan}
                          rowSpan={viewType !== "reportMiniEU" ? 1 : 2}
                          style={dynamic_Table_Colors}
                        >
                          Paint
                        </th>
                        <th className="empty_row" rowSpan={2}></th>
                        <th
                          className={`both-top-border blue-col ${viewType !== "TabView" ? "thead_bottom_border" : ""
                            }`}
                          colSpan={headSpan}
                          rowSpan={viewType !== "reportMiniEU" ? 1 : 2}
                          style={dynamic_Table_Colors}
                        >
                          R & I
                        </th>
                        <th className="empty_row" rowSpan={2}></th>
                        {viewType === "TabView" && (
                          <>
                            {/* <th colSpan={headSpan}>A + E</th> */}
                            <th
                              className="both-top-border dark-gray-col"
                              colSpan={
                                viewType === "TabView" ? headSpan : headSpan
                              }
                              style={dynamic_Table_Colors}
                            >
                              Replace
                            </th>
                            {/* <th colSpan={headSpan}>Replace</th> */}
                          </>
                        )}
                        {viewType === "TabView" && (
                          <th className="empty_row"></th>
                        )}
                        {viewType === "TabView" && (
                          <>
                            {/* <th colSpan={headSpan}>A + E</th> */}
                            <th
                              className="both-top-border dark-gray-col"
                              colSpan={
                                viewType === "TabView" ? headSpan : headSpan
                              }
                              style={dynamic_Table_Colors}
                            >
                              Replace
                            </th>
                            {/* <th colSpan={headSpan}>Replace</th> */}
                          </>
                        )}
                        {viewType === "TabView" && (
                          <th className="empty_row" rowSpan={2}></th>
                        )}
                        <th
                          rowSpan={2}
                          style={{ ...dynamic_Table_Colors, minWidth: "130px" }}
                          className="custom_width_lastrow both-top-border thead_bottom_border"
                        >
                          {viewType === "reportMiniEU"
                            ? "Repair Cost"
                            : "Total"}
                        </th>
                      </tr>
                      {viewType === "TabView" && (
                        <tr>
                          <th
                            className="canadaprice_checkbox_table yellow-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            <i className="fa fa-check"></i>
                          </th>
                          <th
                            className="yellow-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            ({parseInt(ALUPercentage)}%)
                          </th>
                          <th
                            className="canadaprice_checkbox_table blue-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            <i className="fa fa-check"></i>
                          </th>
                          <th
                            className="blue-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            (25%)
                          </th>
                          <th
                            className="canadaprice_checkbox_table green-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            <i className="fa fa-check"></i>
                          </th>
                          <th
                            className="green-col thead_bottom_border min-width-130"
                            style={dynamic_Table_Colors}
                          >
                            -
                          </th>
                          <th
                            className="blue-col thead_bottom_border canadaprice_checkbox_table"
                            style={dynamic_Table_Colors}
                          >
                            <i className="fa fa-check"></i>
                          </th>
                          <th
                            className="blue-col thead_bottom_border replace_inner_text "
                            style={dynamic_Table_Colors}
                          >
                            (25%)
                          </th>
                          <th
                            className="canadaprice_checkbox_table td-border-line dark-gray-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            <i className="fa fa-check"></i>
                          </th>
                          <th
                            className="replace_inner_text dark-gray-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            -
                          </th>
                          <th className="empty_row"></th>
                          <th
                            className="canadaprice_checkbox_table td-border-line dark-gray-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            <i className="fa fa-check"></i>
                          </th>
                          <th
                            className="replace_inner_text dark-gray-col thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            -
                          </th>
                        </tr>
                      )}
                      {viewType === "reportMiniEU" && (
                        <tr>
                          <th
                            className="thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            {`A`}
                          </th>
                          <th
                            className="thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            {`B`}
                          </th>
                          <th
                            className="thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            {`C`}
                          </th>
                          {/* <th>HALF</th> */}
                          <th
                            className="thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            {`D`}
                          </th>
                          <th
                            className="thead_bottom_border"
                            style={dynamic_Table_Colors}
                          >
                            {`E`}
                          </th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      <>
                        {Dents &&
                          Dents.map((row, index) => {
                            const halfLength = Math.ceil(
                              row.arrErsetzen.length / 2
                            );
                            return (
                              !extraParts.includes(row.Part) && (
                                <tr key={index}>
                                  <td
                                    onClick={() =>
                                      this.props.viewType == "TabView" &&
                                      this.toggle(row.Part, true, row.Plastic)
                                    }
                                    style={dynamic_Table_Colors}
                                  >
                                    {getPartName(this.lang(row.Part))}
                                    {/* design */}
                                  </td>
                                  <td className="empty_row"></td>
                                  {viewType !== "reportMiniEU" && (
                                    <td
                                      style={dynamic_Table_Colors}
                                      className="dark-gray-col dent_type_text"
                                    >
                                      {this.getSeverityClass(row).range}
                                    </td>
                                  )}
                                  {viewType === "TabView" && (
                                    <td className="empty_row"></td>
                                  )}
                                  {(viewType === "TabView" ||
                                    viewType === "reportMiniEU") && (
                                      <>
                                        {/* {row.A} */}
                                        <td
                                          style={dynamic_Table_Colors}
                                          className="light-gray-col"
                                        >
                                          {viewType !== "reportMiniEU" ? (
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "100%",
                                              }}
                                            >
                                              <input
                                                name="A"
                                                type="number"
                                                min="0"
                                                style={{
                                                  width: "100%",
                                                  border: "none",
                                                  outline: "none",
                                                  textAlign: "center",
                                                }}
                                                value={row.A}
                                                onChange={(e) => {
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    e,
                                                    index
                                                  );
                                                }}
                                                disabled={isAuthorized}
                                              />
                                              {!isAuthorized && (
                                                <>
                                                  <div className="button-table-arrow-position">
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          Math.max(row.A - 1, 0);
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "A",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="decrement-button"
                                                    >
                                                      -
                                                    </button>
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          row.A + 1;
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "A",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="increment-button"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <p>{row.A}</p>
                                          )}
                                        </td>
                                        {/* {row.B} */}
                                        <td
                                          style={dynamic_Table_Colors}
                                          className="light-gray-col"
                                        >
                                          {viewType !== "reportMiniEU" ? (
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "100%",
                                              }}
                                            >
                                              <input
                                                name="B"
                                                type="number"
                                                min="0"
                                                style={{
                                                  width: "100%",
                                                  border: "none",
                                                  outline: "none",
                                                  textAlign: "center",
                                                }}
                                                value={row.B}
                                                onChange={(e) => {
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    e,
                                                    index
                                                  );
                                                }}
                                                disabled={isAuthorized}
                                              />
                                              {!isAuthorized && (
                                                <>
                                                  <div className="button-table-arrow-position">
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          Math.max(row.B - 1, 0);
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "B",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="decrement-button"
                                                    >
                                                      -
                                                    </button>
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          row.B + 1;
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "B",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="increment-button"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <p>{row.B}</p>
                                          )}
                                        </td>
                                        {/* {row.C} */}
                                        <td
                                          style={dynamic_Table_Colors}
                                          className="light-gray-col"
                                        >
                                          {viewType !== "reportMiniEU" ? (
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "100%",
                                              }}
                                            >
                                              <input
                                                name="C"
                                                type="number"
                                                min="0"
                                                style={{
                                                  width: "100%",
                                                  border: "none",
                                                  outline: "none",
                                                  textAlign: "center",
                                                }}
                                                value={row.C}
                                                onChange={(e) => {
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    e,
                                                    index
                                                  );
                                                }}
                                                disabled={isAuthorized}
                                              />
                                              {!isAuthorized && (
                                                <>
                                                  <div className="button-table-arrow-position">
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          Math.max(row.C - 1, 0);
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "C",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="decrement-button"
                                                    >
                                                      -
                                                    </button>
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          row.C + 1;
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "C",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="increment-button"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <p>{row.C}</p>
                                          )}
                                        </td>
                                        {/* {row.D} */}
                                        <td
                                          style={dynamic_Table_Colors}
                                          className="light-gray-col"
                                        >
                                          {viewType !== "reportMiniEU" ? (
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "100%",
                                              }}
                                            >
                                              <input
                                                name="D"
                                                type="number"
                                                min="0"
                                                style={{
                                                  width: "100%",
                                                  border: "none",
                                                  outline: "none",
                                                  textAlign: "center",
                                                }}
                                                value={row.D}
                                                onChange={(e) => {
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    e,
                                                    index
                                                  );
                                                }}
                                                disabled={isAuthorized}
                                              />
                                              {!isAuthorized && (
                                                <>
                                                  <div className="button-table-arrow-position">
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          Math.max(row.D - 1, 0);
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "D",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="decrement-button"
                                                    >
                                                      -
                                                    </button>
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          row.D + 1;
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "D",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="increment-button"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <p>{row.D}</p>
                                          )}
                                        </td>
                                        {/* {row.E} */}
                                        <td
                                          style={dynamic_Table_Colors}
                                          className="light-gray-col"
                                        >
                                          {viewType !== "reportMiniEU" ? (
                                            <div
                                              style={{
                                                position: "relative",
                                                width: "100%",
                                              }}
                                            >
                                              <input
                                                name="E"
                                                type="number"
                                                min="0"
                                                style={{
                                                  width: "100%",
                                                  border: "none",
                                                  outline: "none",
                                                  textAlign: "center",
                                                }}
                                                value={row.E}
                                                onChange={(e) => {
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    e,
                                                    index
                                                  );
                                                }}
                                                disabled={isAuthorized}
                                              />
                                              {!isAuthorized && (
                                                <>
                                                  <div className="button-table-arrow-position">
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          Math.max(row.E - 1, 0);
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "E",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="decrement-button"
                                                    >
                                                      -
                                                    </button>
                                                    <button
                                                      onClick={() => {
                                                        const updatedValue =
                                                          row.E + 1;
                                                        this.handleDentsChanges(
                                                          row.Part,
                                                          {
                                                            target: {
                                                              name: "E",
                                                              value: updatedValue,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      className="increment-button"
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <p>{row.E}</p>
                                          )}
                                        </td>
                                      </>
                                    )}
                                  <td className="empty_row"></td>
                                  {viewType === "reportMiniEU" && (
                                    <>
                                      <td style={dynamic_Table_Colors}>
                                        <b>{this.getTotalDents(row)}</b>
                                      </td>
                                      <td className="empty_row"></td>
                                    </>
                                  )}
                                  {/* BL */}
                                  <td
                                    style={dynamic_Table_Colors}
                                    className="orange-col"
                                    colSpan={viewType == "TabView" && 2}
                                  >
                                    {viewType == "TabView" ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                        }}
                                      >
                                        <input
                                          name="F"
                                          type="number"
                                          min="0"
                                          max={row.TotalDents}
                                          style={{
                                            width: "100%",
                                            border: "none",
                                            outline: "none",
                                            textAlign: "center",
                                          }}
                                          value={row.F || 0}
                                          onChange={(e) => {
                                            row.TotalDents > 0 && this.handleDentsChanges(
                                              row.Part,
                                              e,
                                              index
                                            );
                                          }}
                                          disabled={isAuthorized}
                                        />
                                        {!isAuthorized && (
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                max={row.TotalDents}
                                                min="0"
                                                onClick={() => {
                                                  const updatedValue =
                                                    Math.max(row.F - 1, 0);
                                                  row.TotalDents > 0 && this.handleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "F",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index
                                                  );
                                                }}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                min="0"
                                                onClick={() => {
                                                  const updatedValue =
                                                    row.F + 1;
                                                  row.TotalDents > 0 && this.handleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "F",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index
                                                  );
                                                }}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    ) : (
                                      <p>{row.F || 0}</p>
                                    )}
                                  </td>
                                  <td className="empty_row"></td>
                                  {/* {viewType === "TabView" && (
                                        <td className="empty_row"></td>
                                      )} */}
                                  {/* ALU */}
                                  <td
                                    className="yellow-col"
                                    style={dynamic_Table_Colors}
                                  >
                                    {viewType === "TabView" ? (
                                      <>
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="Alu"
                                          checked={row.Alu}
                                          id={`${index}_Alu`}
                                          onChange={(e) => {
                                            this.change(row.Part, e, index);
                                          }}
                                          disabled={isAuthorized}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`${index}_Alu`}
                                        ></label>
                                      </>
                                    ) : row.Alu ? (
                                      <span style={{ fontSize: "15px" }}>
                                        <i className="fa fa-check"></i>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  {/* ALU value */}
                                  {viewType === "TabView" && (
                                    <td
                                      style={dynamic_Table_Colors}
                                      className="yellow-col"
                                    >
                                      {row.Alu &&
                                        (
                                          (this.getOriginalPrice(row, true) *
                                            parseFloat(ALUPercentage)) /
                                          100
                                        ).toFixed(2)}
                                    </td>
                                  )}
                                  <td className="empty_row"></td>
                                  {/* Glue Checkbox */}
                                  <td
                                    style={dynamic_Table_Colors}
                                    className="blue-col"
                                  >
                                    {viewType === "TabView" ? (
                                      <>
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="Glue"
                                          checked={row.Glue}
                                          id={`${index}_Glue`}
                                          onChange={(e) => {
                                            this.change(row.Part, e, index);
                                          }}
                                          disabled={isAuthorized}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`${index}_Glue`}
                                        ></label>
                                      </>
                                    ) : row.Glue ? (
                                      <span style={{ fontSize: "15px" }}>
                                        <i className="fa fa-check"></i>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  {/* Glue Value */}
                                  {viewType === "TabView" && (
                                    <td
                                      style={dynamic_Table_Colors}
                                      className="blue-col"
                                    >
                                      {row.Glue &&
                                        (
                                          (this.getOriginalPrice(row, true) *
                                            parseFloat(glue_percentage)) /
                                          100
                                        ).toFixed(2)}
                                    </td>
                                  )}
                                  <td className="empty_row"></td>
                                  {/* Paint checkbox */}
                                  <td
                                    style={dynamic_Table_Colors}
                                    className="green-col"
                                  >
                                    {viewType === "TabView" ? (
                                      <>
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          name="Push2paint"
                                          checked={row.Push2paint}
                                          id={`${index}_Push2paint`}
                                          onChange={(e) => {
                                            this.change(
                                              row.Part,
                                              e,
                                              index,
                                              true
                                            );
                                          }}
                                          disabled={
                                            (!row.hasOwnProperty(
                                              "corrosionProtection"
                                            )
                                              ? !row.corrosionProtection &&
                                              !row.Push2paint
                                              : !row.corrosionProtection) ||
                                            isAuthorized
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`${index}_Push2paint`}
                                        ></label>
                                      </>
                                    ) : row.Push2paint ? (
                                      <span style={{ fontSize: "15px" }}>
                                        <i className="fa fa-check"></i>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  {viewType === "TabView" && (
                                    <td
                                      style={dynamic_Table_Colors}
                                      className="green-col"
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                        }}
                                      >
                                        <input
                                          className="pushpaint_input"
                                          type="number"
                                          style={{
                                            border: "none",
                                            outline: "none",
                                            textAlign: "center",
                                          }}
                                          name="corrosionProtection"
                                          value={row.corrosionProtection || ""}
                                          min={0}
                                          disabled={
                                            row.Push2paint ||
                                            totalCorrosionProtection >= 30 ||
                                            isAuthorized
                                          }
                                          onChange={(e) => {
                                            this.handleDentsChanges(
                                              row.Part,
                                              e,
                                              index
                                            );
                                          }}
                                        />
                                        {!row.Push2paint &&
                                          totalCorrosionProtection < 30 &&
                                          !isAuthorized && (
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(
                                                    (row.corrosionProtection ||
                                                      0) - 1,
                                                    0
                                                  );
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "corrosionProtection",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index
                                                  );
                                                }}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue =
                                                    (row.corrosionProtection ||
                                                      0) + 1;
                                                  this.handleDentsChanges(
                                                    row.Part,
                                                    {
                                                      target: {
                                                        name: "corrosionProtection",
                                                        value: updatedValue,
                                                      },
                                                    },
                                                    index
                                                  );
                                                }}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          )}
                                      </div>
                                    </td>
                                  )}
                                  <td className="empty_row"></td>
                                  {/* Replace checkbox */}
                                  <td
                                    style={dynamic_Table_Colors}
                                    className="blue-col p-0 align-tex"
                                    colSpan={((viewType === "TabView") && (row.Part == "Roof" || row.Part == "TrunkCover")) ? 2 : 0}
                                  >
                                    {viewType === "TabView" ? (
                                      row.Part === "Roof" ? (
                                        <>
                                          {roofAdditionalParts.map((val, i) => (
                                            <tr key={i} className="tickmark_row">
                                              <td>
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content ml-2">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input"
                                                      name={val.value}
                                                      checked={
                                                        Array.isArray(Dents[index]["AdditionalRIPart"]) &&
                                                        Dents[index]["AdditionalRIPart"].includes(val.value)
                                                      }
                                                      id={`${index}_Replace_${i}`}
                                                      onChange={(e) => this.changeAdditionalPart(e, index, val.value)}
                                                      disabled={isAuthorized}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={`${index}_Replace_${i}`}
                                                    >
                                                      {this.lang(val.value)}
                                                    </label>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </>
                                      ) : row.Part === "TrunkCover" ? (
                                        <>
                                          {trunkAdditionalParts.map((val, i) => (
                                            <tr key={i} className="tickmark_row">
                                            <td style={{backgroundColor:"transparent"}}>
                                              <div className="alu_input_main ml-2">
                                                <div className="alu_input_content">
                                              <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                name={val.value}
                                                checked={
                                                  Array.isArray(Dents[index]["AdditionalRIPart"]) &&
                                                  Dents[index]["AdditionalRIPart"].includes(val.value)
                                                }
                                                id={`${index}_Replace_${i}`}
                                                onChange={(e) => this.changeAdditionalPart(e, index, val.value)}
                                                disabled={isAuthorized}
                                              />
                                              <label
                                                className="custom-control-label"
                                                htmlFor={`${index}_Replace_${i}`}
                                              >
                                                {this.lang(val.value)}
                                              </label>
                                              </div>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </>
                                      ) : (
                                        // Render single checkbox for non-Roof parts in TabView
                                        <>
                                          <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            name="Replace"
                                            checked={row.Replace}
                                            id={`${index}_Replace`}
                                            onChange={(e) => {
                                              this.change(row.Part, e, index);
                                            }}
                                            disabled={isAuthorized}
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor={`${index}_Replace`}
                                          ></label>
                                        </>
                                      )
                                    ) : // For non-TabView, display an icon if row.Replace is true
                                      row.Replace ? (
                                        <span style={{ fontSize: "15px" }}>
                                          <i className="fa fa-check"></i>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                  </td>
                                  {/* Replace value */}
                                  {((viewType === "TabView") && (row.Part != "Roof" && row.Part != "TrunkCover")) && (
                                    <td
                                      style={dynamic_Table_Colors}
                                      className="blue-col"
                                    >

                                      {row.Replace &&
                                        (
                                          (this.getOriginalPrice(row, true) *
                                            parseFloat(replace_percentage)) /
                                          100
                                        ).toFixed(2)}
                                    </td>
                                  )}
                                  {viewType === "TabView" && (
                                    <td className="empty_row"></td>
                                  )}
                                  {/* Replace */}
                                  {viewType === "TabView" && (
                                    <>
                                      <td
                                        colSpan={2}
                                        className="p-0 align-text dark-gray-col tickmark_row"
                                        style={dynamic_Table_Colors}
                                      >
                                        <table className="inner-table custom_table_row w-100">
                                          {row.arrErsetzen &&
                                            row.arrErsetzen.length
                                            ? row.arrErsetzen
                                              .slice(0, halfLength)
                                              .map((checkbox_val, i) => {
                                                return (
                                                  <tr>
                                                    <td
                                                      className={
                                                        i === halfLength - 1
                                                          ? "td-border-line-none dark-gray-col"
                                                          : "td-border-line last-line-none"
                                                      }
                                                    >
                                                      <div className="alu_input_main">
                                                        <div className="alu_input_content">
                                                          <input
                                                            className="custom-control-input"
                                                            type="checkbox"
                                                            id={`${index}_Replace_Part_firstCol_${i}`}
                                                            checked={
                                                              Array.isArray(
                                                                Dents[index][
                                                                "Ersetzen"
                                                                ]
                                                              ) &&
                                                                Dents[index][
                                                                  "Ersetzen"
                                                                ].includes(
                                                                  checkbox_val
                                                                )
                                                                ? true
                                                                : false
                                                            }
                                                            onChange={(
                                                              event
                                                            ) =>
                                                              this.changeErsetzen(
                                                                event,
                                                                index,
                                                                checkbox_val
                                                              )
                                                            }
                                                            disabled={
                                                              isAuthorized
                                                            }
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor={`${index}_Replace_Part_firstCol_${i}`}
                                                          ></label>
                                                        </div>
                                                        <div className="alu_para_content">
                                                          <p className="p-0 m-0">
                                                            {this.lang(
                                                              checkbox_val
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              })
                                            : "-"}
                                        </table>
                                      </td>
                                      <td className="empty_row"></td>
                                      <td
                                        colSpan={2}
                                        className="p-0 align-text dark-gray-col tickmark_row"
                                      >
                                        <table className="inner-table custom_table_row w-100">
                                          {row.arrErsetzen &&
                                            row.arrErsetzen.length
                                            ? row.arrErsetzen
                                              .slice(halfLength)
                                              .map((checkbox_val, i) => {
                                                return (
                                                  <tr>
                                                    <td
                                                      // className="td-border-line"
                                                      className={
                                                        i === halfLength - 1
                                                          ? "td-border-line-none "
                                                          : "td-border-line last-line-none"
                                                      }
                                                    >
                                                      <div className="alu_input_main">
                                                        <div className="alu_input_content">
                                                          <input
                                                            className="custom-control-input"
                                                            type="checkbox"
                                                            id={`${index}_Replace_Part_secondCol_${i}`}
                                                            checked={
                                                              Array.isArray(
                                                                Dents[index][
                                                                "Ersetzen"
                                                                ]
                                                              ) &&
                                                                Dents[index][
                                                                  "Ersetzen"
                                                                ].includes(
                                                                  checkbox_val
                                                                )
                                                                ? true
                                                                : false
                                                            }
                                                            onChange={(
                                                              event
                                                            ) =>
                                                              this.changeErsetzen(
                                                                event,
                                                                index,
                                                                checkbox_val
                                                              )
                                                            }
                                                            disabled={
                                                              isAuthorized
                                                            }
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor={`${index}_Replace_Part_secondCol_${i}`}
                                                          ></label>
                                                        </div>
                                                        <div className="alu_para_content">
                                                          <p className="p-0 m-0">
                                                            {this.lang(
                                                              checkbox_val
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              })
                                            : "-"}
                                        </table>
                                      </td>
                                    </>
                                  )}
                                  <td className="empty_row"></td>
                                  <td
                                    className={`${this.getAluGlueAddedPrice(row).split(" ").length > 1 ? "text-danger" : ""}`}
                                    style={{
                                      ...dynamic_Table_Colors,
                                      minWidth: "130px",
                                    }}
                                  >
                                    {ShowPrice &&
                                      this.getAluGlueAddedPrice(row)}
                                  </td>
                                </tr>
                              )
                            );
                          })}
                      </>
                      <tr className="canada_footer_row">
                        <td
                          className="both-bottom-border"
                          style={dynamic_Table_Colors}
                        >
                          {this.lang("Total")}
                        </td>
                        <td className="empty_row"></td>
                        {viewType !== "reportMiniEU" && (
                          <td className="both-bottom-border" style={dynamic_Table_Colors}>-</td>
                        )}
                        {viewType === "TabView" && (
                          <td className="empty_row"></td>
                        )}
                        {(viewType === "TabView" ||
                          viewType === "reportMiniEU") && (
                            <>
                              {/* Total A */}
                              <td style={dynamic_Table_Colors} className="bottom-left-border">
                                {Dents &&
                                  Dents.reduce((acc, num) => {
                                    if (!extraParts.includes(num.Part)) {
                                      return (
                                        parseFloat(acc) + parseFloat(num.A || 0)
                                      );
                                    } else {
                                      return parseFloat(acc);
                                    }
                                  }, 0)}
                              </td>
                              {/* Total B */}
                              <td style={dynamic_Table_Colors}>
                                {Dents &&
                                  Dents.reduce((acc, num) => {
                                    if (!extraParts.includes(num.Part)) {
                                      return (
                                        parseFloat(acc) + parseFloat(num.B || 0)
                                      );
                                    } else {
                                      return parseFloat(acc);
                                    }
                                  }, 0)}
                              </td>
                              {/* Total C */}
                              <td style={dynamic_Table_Colors}>
                                {Dents &&
                                  Dents.reduce((acc, num) => {
                                    if (!extraParts.includes(num.Part)) {
                                      return (
                                        parseFloat(acc) + parseFloat(num.C || 0)
                                      );
                                    } else {
                                      return parseFloat(acc);
                                    }
                                  }, 0)}
                              </td>
                              {/* total D */}
                              <td style={dynamic_Table_Colors}>
                                {Dents &&
                                  Dents.reduce((acc, num) => {
                                    if (!extraParts.includes(num.Part)) {
                                      return (
                                        parseFloat(acc) +
                                        parseFloat(num.D ? num.D : 0)
                                      );
                                    } else {
                                      return parseFloat(acc);
                                    }
                                  }, 0)}
                              </td>
                              {/* total E */}
                              <td style={dynamic_Table_Colors} className="bottom-right-border">
                                {Dents &&
                                  Dents.reduce((acc, num) => {
                                    if (!extraParts.includes(num.Part)) {
                                      return (
                                        parseFloat(acc) +
                                        parseFloat(num.E ? num.E : 0)
                                      );
                                    } else {
                                      return parseFloat(acc);
                                    }
                                  }, 0)}
                              </td>
                            </>
                          )}
                        <td className="empty_row"></td>
                        {viewType === "reportMiniEU" && (
                          <>
                            <td style={dynamic_Table_Colors} className="both-bottom-border">
                              <b>
                                {Dents &&
                                  Dents.reduce((acc, num) => {
                                    if (!extraParts.includes(num.Part)) {
                                      return (
                                        parseFloat(acc) + this.getTotalDents(num)
                                      );
                                    } else {
                                      return parseFloat(acc);
                                    }
                                  }, 0)}
                              </b>
                            </td>
                            <td className="empty_row"></td>
                          </>
                        )}
                        {/* BL */}
                        <td className="both-bottom-border" style={dynamic_Table_Colors} colSpan={viewType == "TabView" && 2}
                        >
                          {Dents &&
                            Dents.reduce((acc, num) => {
                              if (!extraParts.includes(num.Part)) {
                                return (
                                  parseFloat(acc) +
                                  parseFloat(num.F ? num.F : 0)
                                );
                              } else {
                                return parseFloat(acc);
                              }
                            }, 0)}
                        </td>
                        {/* {viewType === "reportMiniEU" && ( */}
                        <td className="empty_row"></td>
                        {/* )} */}
                        {viewType == "reportMiniEU" && (
                          <td style={dynamic_Table_Colors} className="both-bottom-border">-</td>
                        )}
                        {/* <td style={dynamic_Table_Colors}>-</td>
                        {viewType === "TabView" && (
                          <td className="empty_row"></td>
                        )} */}
                        {viewType === "reportMiniCanada" && (
                          <td className="empty_row"></td>
                        )}
                        {/* {viewType === "reportFullCanada" && (
                          <td className="empty_row"></td>
                        )} */}
                        {viewType !== "reportMiniEU" && (
                          <td
                            className={`${this.props.viewType === 'TabView' ? "bottom-left-border" : "both-bottom-border"}`}
                            style={dynamic_Table_Colors}>-</td>
                        )}
                        {/* Total ALU */}
                        {viewType === "TabView" && (
                          <td style={dynamic_Table_Colors} className="bottom-right-border">
                            {Dents &&
                              Dents.reduce((acc, num) => {
                                if (!extraParts.includes(num.Part) && num.Alu) {
                                  return (
                                    parseFloat(acc) +
                                    parseFloat(
                                      (this.getOriginalPrice(num, true) *
                                        parseFloat(ALUPercentage)) /
                                      100
                                    )
                                  );
                                } else {
                                  return parseFloat(acc);
                                }
                              }, 0)}
                          </td>
                        )}
                        <td className="empty_row"></td>
                        {viewType === "TabView" && (
                          <td className="bottom-left-border" style={dynamic_Table_Colors}>-</td>
                        )}
                        {/* Total Glue */}
                        {viewType === "TabView" && (
                          <td className="bottom-right-border" style={dynamic_Table_Colors}>
                            {Dents &&
                              Dents.reduce((acc, num) => {
                                if (
                                  !extraParts.includes(num.Part) &&
                                  num.Glue
                                ) {
                                  return (
                                    parseFloat(acc) +
                                    parseFloat(
                                      (this.getOriginalPrice(num, true) *
                                        parseFloat(glue_percentage)) /
                                      100
                                    )
                                  );
                                } else {
                                  return parseFloat(acc);
                                }
                              }, 0)}
                          </td>
                        )}
                        {viewType === "TabView" && (
                          <td className="empty_row"></td>
                        )}
                        <td
                          className={`${this.props.viewType === 'TabView' ? "bottom-left-border" : "both-bottom-border"}`}
                          style={dynamic_Table_Colors}>-</td>
                        {/* Total Corrosion Protection */}
                        {viewType === "TabView" && (
                          <td className="bottom-right-border" style={dynamic_Table_Colors}>
                            {this.getTotalCorrosionProtection()}
                          </td>
                        )}
                        <td className="empty_row"></td>
                        <td
                          className={`${this.props.viewType === 'TabView' ? "bottom-left-border" : "both-bottom-border"}`}
                          style={dynamic_Table_Colors}>-</td>
                        {/* Total Replace */}
                        {viewType === "TabView" && (
                          <>
                            <td className="bottom-right-border" style={dynamic_Table_Colors}>
                              {Dents &&
                                Dents.reduce((acc, num) => {
                                  if (
                                    !extraParts.includes(num.Part) &&
                                    num.Replace
                                  ) {
                                    return (
                                      parseFloat(acc) +
                                      parseFloat(
                                        (this.getOriginalPrice(num, true) *
                                          parseFloat(replace_percentage)) /
                                        100
                                      )
                                    );
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)}
                            </td>
                            <td className="empty_row"></td>
                            {/* A + E */}
                            <td className="bottom-left-border" style={dynamic_Table_Colors}>-</td>
                            <td className="bottom-right-border" style={dynamic_Table_Colors}>-</td>
                            <td className="empty_row"></td>
                            {/* Replace */}
                            <td className="bottom-left-border" style={dynamic_Table_Colors}>-</td>
                            <td className="bottom-right-border" style={dynamic_Table_Colors}>-</td>
                          </>
                        )}
                        <td className="empty_row"></td>
                        {viewType !== "TabView" && (
                          <>
                            <td style={dynamic_Table_Colors} className="both-bottom-border">-</td>
                            <td className="empty_row"></td>
                          </>
                        )}
                        {/* Total Amount */}
                        <td className="text-right both-bottom-border" style={dynamic_Table_Colors}>
                          {ShowPrice && this.getTotal()}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="dat_height"></td>
                      </tr>
                      <tr className="canada_footer_header">
                        <td className="canada_footer_blank_row"
                          colSpan={
                            viewType === "reportMiniEU"
                              ? 8
                              : viewType === "TabView"
                                ? 10
                                : 4
                          }
                          rowSpan={4}></td>
                        <td
                          style={dynamic_Table_Colors}
                          colSpan={
                            viewType === "reportMiniEU"
                              ? 11
                              : viewType === "TabView"
                                ? 20
                                : 9
                          }
                          className="text-right both-top-border"
                        >
                          <span>Additional R/I</span>
                            {
                              viewType !== "TabView" && (
                                <>
                                  <br />
                                  <span className="font-weight-bold">
                                    {this.showAdditionalRiParts().length > 0 && `(${this.showAdditionalRiParts()
                                      .map((part) => this.lang(part))
                                      .join(', ')})`}
                                  </span>
                                </>
                              )
                            }
                        </td>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          className="text-right both-top-border grandtotal_calculation_innerow"
                        >
                          <table class="w-100 footer-inner-table">
                            <tr>
                              <td class="p-0 text-left">$</td>
                              <td class="text-right total_calculation_innerow">
                                {ShowPrice && `${this.getAdditionalRI()}`}
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr className="canada_footer_innerrow">
                        <td
                          style={dynamic_Table_Colors}
                          className="text-right"
                          colSpan={
                            viewType === "reportMiniEU"
                              ? 9
                              : viewType === "TabView"
                                ? 17
                                : 7
                          }
                        >
                          {this.lang("Car Type")}
                        </td>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          colSpan={
                            viewType === "reportMiniEU"
                              ? 1
                              : viewType === "TabView"
                                ? 2
                                : 1
                          }
                          className="text-right"
                        >
                          {
                            viewType === "TabView" ? (
                              <select
                                onChange={(e) => this.handleChageCarType(e)}
                                placeholder="Select Car Type"
                                name="CarType"
                                className="cartype_dropdown"
                                value={
                                  data.CarType
                                    ? data.CarType
                                    : (data.CarType = "Normal")
                                }
                                disabled={isAuthorized}
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  width: "100%",
                                  fontSize: "14px",
                                }}
                              >
                                {["Normal", ...CarTypeArr].map((car, i) => (
                                  <option value={car} key={i}>
                                    {this.lang(car)}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <span className="font-weight-bold">
                                {this.lang(data.CarType)}
                              </span>
                            )
                          }

                        </td>

                        <td className="empty_row"></td>

                        <td
                          style={dynamic_Table_Colors}
                          className="text-right grandtotal_calculation_innerow"
                        >
                          <table class="w-100 footer-inner-table">
                            <tr>
                              <td class="p-0 text-left">$</td>
                              <td class="text-right total_calculation_innerow">
                                {ShowPrice && `${this.getCartypeValue()}`}
                              </td>
                            </tr>
                          </table>

                        </td>
                      </tr>
                      <tr className="grandtotal_calculation_main_row">
                        <td
                          style={dynamic_Table_Colors}
                          colSpan={
                            viewType === "reportMiniEU"
                              ? 11
                              : viewType === "TabView"
                                ? 20
                                : 9
                          }
                          className="text-right both-bottom-border"
                        >
                          <span>
                            Grand total
                          </span>
                        </td>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          className="text-right both-bottom-border p-0 grandtotal_calculation_innerow"
                        >
                          <table class="w-100 footer-inner-table">
                            <tr>
                              <td class="p-0 text-left"><b>$</b></td>
                              <td class="text-right total_calculation_innerow">
                                <b class="p-0 m-0">
                                  {ShowPrice && `${this.getGrandTotal()}`}
                                  {ShowPrice && this.isCRIncludes() && " + CR"}
                                </b></td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          ) : null}
          {this.props.is_extra_columns_visible_mini_fullreport ? (
            <div
              className={`row all-price-table-wrapper swiss_price_table_all usprice_table_main canada-table-row-left-right mpi-price-table ${viewType !== "TabView" ? "canada-tableview-wrapper" : ""
                }`}
            >
              <div className="col-lg-12 p-0">
                <div className="table-responsive">
                  <table width="100%" className="table w-100">
                    <thead>
                      <tr width="100%">
                        <th
                          width="33%"
                          style={dynamic_Table_Colors}
                          className="both-top-border part-tr"
                        >
                          {this.lang("Damage Description")}
                        </th>
                        <th className="empty_row"></th>
                        <th
                          width="33%"
                          style={dynamic_Table_Colors}
                          className="both-top-border replace-tr row-ae"
                        >
                          {this.lang("Replace")}
                        </th>
                        <th className="empty_row"></th>
                        <th
                          width="33%"
                          style={dynamic_Table_Colors}
                          className="both-top-border ersetzen-tr row-replace"
                        >
                          {this.lang("Replace")}
                        </th>
                      </tr>
                    </thead>
                    <tbody width="100%">
                      {Dents &&
                        Dents.map((row, index) => {
                          const halfLength = Math.ceil(
                            row.arrErsetzen &&
                            row.arrErsetzen.length > 0 &&
                            row.arrErsetzen.length / 2
                          );
                          return (
                            row.Part !== "LeftFrontTyre" &&
                            row.Part !== "RightRoofFrame" &&
                            row.Part !== "LeftRoofFrame" &&
                            row.Part !== "Trunk" &&
                            row.Part !== "LeftBackTyre" &&
                            row.Part !== "RightFrontTyre" &&
                            row.Part !== "RightBackTyre" &&
                            row.Part !== "FrontBumper" &&
                            row.Part !== "BackBumper" &&
                            row.Part !== "Underbody" &&
                            row.Part !== "Inside" && (
                              <tr className="" key={index}>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <p className="p-0 m-0">
                                    {this.lang(row.Part)}
                                  </p>
                                </td>
                                <td className="empty_row"></td>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {row.arrErsetzen &&
                                        row.arrErsetzen.length &&
                                        row.arrErsetzen
                                          .slice(0, halfLength)
                                          .map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex demo-flex-main">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        className="cross_input_table"
                                                        type="checkbox"
                                                        disabled={isAuthorized}
                                                        checked={
                                                          Array.isArray(
                                                            Dents[index][
                                                            "Ersetzen"
                                                            ]
                                                          ) &&
                                                            Dents[index][
                                                              "Ersetzen"
                                                            ].includes(
                                                              checkbox_val
                                                            )
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">
                                                        {this.lang(
                                                          checkbox_val
                                                        )}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {row.arrErsetzen &&
                                        row.arrErsetzen.length &&
                                        row.arrErsetzen
                                          .slice(halfLength)
                                          .map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex text-left demo-flex-main">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        className="cross_input_table"
                                                        type="checkbox"
                                                        disabled={isAuthorized}
                                                        checked={
                                                          Array.isArray(
                                                            Dents[index][
                                                            "Ersetzen"
                                                            ]
                                                          ) &&
                                                            Dents[index][
                                                              "Ersetzen"
                                                            ].includes(
                                                              checkbox_val
                                                            )
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">
                                                        {this.lang(
                                                          checkbox_val
                                                        )}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : null}
        </div>
        {modal && (
          <Lightbox
            reactModalStyle={{
              overlay: { zIndex: 100000000 },
              content: {},
            }}
            mainSrc={
              this.state.filteredImages.length > 0
                ? `${this.state.filteredImages[this.state.currentImageIndex]
                }?t=${new Date().getTime()}` // Append timestamp
                : require("../../assets/img/brand/dashboard-error-logo.png")
            }
            imageCaption={
              this.state.filteredImages.length > 0 &&
              this.lang(
                this.state.filteredImages[this.state.currentImageIndex]
                  .split("/")
                  .pop()
                  .replace(/^Report_/, "")
                  .replace(/_\d+\.jpg$/, "")
              )
            }
            nextSrc={`${this.state.filteredImages[
              (this.state.currentImageIndex + 1) %
              this.state.filteredImages.length
            ]
              }?t=${new Date().getTime()}`}
            prevSrc={`${this.state.filteredImages[
              (this.state.currentImageIndex +
                this.state.filteredImages.length -
                1) %
              this.state.filteredImages.length
            ]
              }?t=${new Date().getTime()}`}
            onCloseRequest={() => this.setState({ modal: false })}
            onMovePrevRequest={() =>
              this.setState({
                currentImageIndex:
                  (this.state.currentImageIndex +
                    this.state.filteredImages.length -
                    1) %
                  this.state.filteredImages.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                currentImageIndex:
                  (this.state.currentImageIndex + 1) %
                  this.state.filteredImages.length,
              })
            }
            onImageLoadError={(...events) => console.log(events)}
            imageLoadErrorMessage={
              <img
                style={{ height: "100%", width: "100%" }}
                src={require("../../assets/img/brand/dashboard-error-logo.png")}
              />
            }
          />
        )}
      </>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    toggleReportDamageImage: props.toggleReportDamageImage,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchtoProps
)(SgiEstevanPriceTable);
